import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFiles: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFiles"><Path fillRule="evenodd" clipRule="evenodd" d="M7 5H4V22H18V19H21V8.5H14.5V2H7V5ZM7 6.5V19H16.5V20.5H5.5V6.5H7Z" fill="currentColor"/><Path d="M16 2.43934L20.5607 7H16V2.43934Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFiles;
